/**
 * arreglo con todos los generos que hay en MakeMake
 */
export const GENRES = [
    {
        id: 'Interactivo',
        type:'genero',
        name: {
            defaultValue: 'Interactivo',
            translationPath:'content.seccion.generos.interactivo'
        },
        imgPath:'/img/generos/interactivo.png',
        mostSearched: true,
        position: 1,
        mostSearchedMobile: true,
        positionMobile: 1,
    },
    {
        id: 'Crónica y ensayo',
        type: 'genero',
        name: {
            defaultValue: 'Crónica',
            translationPath: 'content.seccion.generos.cronica'
        },
        imgPath: '/img/generos/cronica.png',
        mostSearched: true,
        position: 2,
        mostSearchedMobile: true,
        positionMobile: 5,
    },
    {
        id: 'Cómic',
        type: 'genero',
        name: {
            defaultValue: 'Cómic',
            translationPath: 'content.seccion.generos.comic'
        },
        imgPath: '/img/generos/comic.png',
        mostSearched: true,
        position: 3,
        mostSearchedMobile: true,
        positionMobile: 2,
    },
    {
        id: 'Didáctico',
        type: 'genero',
        name: {
            defaultValue: 'Didáctico',
            translationPath: 'content.seccion.generos.didactico'
        },
        imgPath: '/img/generos/didactico.png',
        mostSearched: false,
        position: 0,
        mostSearchedMobile: false,
        positionMobile: 0,
    },
    {
        id: 'Libro álbum',
        type: 'genero',
        name: {
            defaultValue: 'Libro álbum',
            translationPath: 'content.seccion.generos.libro_album'
        },
        imgPath: '/img/generos/libro-album.png',
        mostSearched: true,
        position: 5,
        mostSearchedMobile: true,
        positionMobile: 3,
    },
    {
        id: 'Novela',
        type: 'genero',
        name: {
            defaultValue: 'Novela',
            translationPath: 'content.seccion.generos.novela'
        },
        imgPath: '/img/generos/novela.png',
        mostSearched: true,
        position: 4,
        mostSearchedMobile: false,
        positionMobile: 0,
    },
    {
        id: 'Cuento',
        type: 'genero',
        name: {
            defaultValue: 'Cuento',
            translationPath: 'content.seccion.generos.cuento'
        },
        imgPath: '/img/generos/cuento.png',
        mostSearched: true,
        position: 7,
        mostSearchedMobile: true,
        positionMobile: 4,
    },
    {
        id: 'Informativo',
        type: 'genero',
        name: {
            defaultValue: 'Informativo',
            translationPath:'content.seccion.generos.informativo'
        },
        imgPath: '/img/generos/informativo.png',
        mostSearched: true,
        position: 6,
        mostSearchedMobile: true,
        positionMobile: 6,
    },
    {
        id: 'Teatro',
        type: 'genero',
        name: {
            defaultValue: 'Teatro',
            translationPath: 'content.seccion.generos.teatro'
        },
        imgPath: '/img/generos/teatro.png',
        mostSearched: true,
        position: 10,
    },
    {
        id: 'Poesía',
        type: 'genero',
        name: {
            defaultValue: 'Poesía',
            translationPath: 'content.seccion.generos.poesia'
        },
        imgPath: '/img/generos/poesia.png',
        mostSearchedMobile: true,
        positionMobile: 8,
        mostSearched: true,
        position: 8,
    },
    {
        id: 'Cuento ilustrado',
        type: 'genero',
        name: {
            defaultValue: 'Cuento ilustrado',
            translationPath: 'content.seccion.generos.cuento_ilustrado'
        },
        imgPath:'/img/generos/cuento-ilustrado.png',
        mostSearched: true,
        position: 9,
        mostSearchedMobile: true,
        positionMobile: 7,
    },
]